import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function Philosophy() {
  const {
    t
  } = useLanguage();
  const p = t.philosophy;
  return <section id="philosophy" aria-labelledby="philosophy-title" className="scroll-mt-20 bg-cream py-24 md:py-36" data-id="element-246" data-mp="3dzrs9wg1ye0f">
      <div className="mx-auto max-w-4xl px-6 md:px-10" data-id="element-247" data-mp="354tvufdp4j4c">
        <h2 id="philosophy-title" className="text-center text-[14px] font-semibold text-violet" data-id="element-248" data-mp="353ivkpjglthz">
          {p.title}
        </h2>
        <p className="mx-auto mt-6 max-w-3xl text-center font-serif text-[32px] italic leading-[1.3] text-ink md:text-[46px]" data-id="element-249" data-mp="2v77bhddmnzcz">
          {p.opening}
        </p>

        <div className="mt-16 md:mt-20" data-id="element-250" data-mp="2h9r7e8it0hoe">
          <p className="text-[15px] text-muted" data-id="element-251" data-mp="2m6990ziu7zwi">{p.learnLabel}</p>
          <ul className="mt-4" data-id="element-252" data-mp="2m8lyryuu7ek4">
            {p.lessons.map(lesson => <li key={lesson} className="border-t border-line py-5 font-serif text-[21px] leading-snug text-ink last:border-b md:text-[26px]" data-id="element-253" data-mp="fgupq2ue2gvb">
                {lesson}
              </li>)}
          </ul>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center text-[17px] text-muted" data-id="element-254" data-mp="138rkahmevvcd">{p.closing}</p>
      </div>
    </section>;
}